import React from 'react'
import { string, object } from 'prop-types'
import { EventAgenda as EventAgenda2 } from '@/component/Primitive/Events/components/EventAgenda2'

const EventAgendaWidget = ({ images, pageData, ...other }) => {
  const getImage = (imageList, context, ratio, size) =>
    imageList?.[`${context}_${ratio}_${size}`]?.[0]

  const backgroundImage = getImage(images, 'desktop_background', '72x17', 720)
    ?.url

  const event = pageData?.eventUmbrella?.event

  const embellishedEvent = {
    ...event,
    agenda: event?.agenda?.map((item) => {
      const speakers = item?.speakers
      return {
        ...item,
        speakers: speakers?.map((speaker) => {
          const speakerImage = getImage(speaker?.images, 'speaker', '1x1', 320)
            ?.url
          return {
            ...speaker,
            image: {
              alt: 'Event Agenda Speaker Placeholder',
              sizes: ['min-width(960px) 50vw', '100vw'],
              src: speakerImage
            }
          }
        })
      }
    })
  }

  return (
    // <>
    //   <EventAgenda
    //     backgroundImage={backgroundImage}
    //     event={embellishedEvent}
    //     {...other}
    //   />
    <EventAgenda2
      backgroundImage={backgroundImage}
      event={embellishedEvent}
      {...other}
    />
    // </>
  )
}

EventAgendaWidget.propTypes = {
  theme: string,
  pageData: object,
  images: object
}

export default EventAgendaWidget
